import { render } from "./NavigationPhoneMenuItem.vue?vue&type=template&id=0d84e39d"
import script from "./NavigationPhoneMenuItem.vue?vue&type=script&lang=js"
export * from "./NavigationPhoneMenuItem.vue?vue&type=script&lang=js"

import "./NavigationPhoneMenuItem.vue?vue&type=style&index=0&id=0d84e39d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__